import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Document, Partner, Share, SharesTitle } from 'types';
import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';
import PartnerSharesTableHeader from './PartnerSharesTableHeader';
import PartnerSharesTableBody from './PartnerSharesTableBody';
import PartnerSharesTableFooter from './PartnerSharesTableFooter';
import { getSharesCountTotal } from '../utils/getSharesCountTotal';

type PartnerSharesTableProps = {
  partnerId: string;
  shares: Share[];
  sharesTitles: SharesTitle[];
  currentPage: number;
  rowsPerPage: number;
  isAdmin: boolean;
  hasSharesTitlesEnabled: boolean;
  societySharesTitleDocument?: Document;
  isCoOwner?: boolean;
  fetchPartnerData: () => void;
};

const PartnerSharesTable: FC<PartnerSharesTableProps> = ({
  partnerId,
  shares,
  sharesTitles,
  societySharesTitleDocument,
  currentPage,
  rowsPerPage,
  isAdmin,
  hasSharesTitlesEnabled,
  isCoOwner,
  fetchPartnerData,
}: PartnerSharesTableProps) => {
  const { t } = useTranslate();

  const sharesCountTotal = getSharesCountTotal(shares);

  return (
    <>
      <table className="table table-striped table-font-sm">
        <PartnerSharesTableHeader
          isAdmin={isAdmin}
          isCoOwner={isCoOwner}
          hasSharesTitlesEnabled={hasSharesTitlesEnabled}
        />
        {shares?.length > 0 ? (
          <>
            <PartnerSharesTableBody
              partnerId={partnerId}
              shares={shares}
              sharesTitles={sharesTitles}
              societySharesTitleDocument={societySharesTitleDocument}
              currentPage={currentPage}
              rowsPerPage={rowsPerPage}
              isCoOwner={isCoOwner}
              fetchPartnerData={fetchPartnerData}
            />
            <PartnerSharesTableFooter sharesCountTotal={sharesCountTotal} />
          </>
        ) : (
          <EmptyStateForTable
            mainMessage={t('ThisPartnerHasNoShares')}
            infoMessage=""
            colspan={7}
          />
        )}
      </table>
    </>
  );
};

export default PartnerSharesTable;
